import React from 'react'
import Container from '@material-ui/core/Container'
import DashboardHeader from '../DashboardHeader'
import Layout from '../Layout'
import MyBidsPanel from '../../../utils/CommonFunctionality/MyBidsPanel'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Dashboard = (props) => {
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    return (
        <>
            <SEOTAG page="Mybids" />
            <Layout props={props}>
                {isVarifiedGfTheme ? (
                    <div className="GFdashWrapperContainer">
                        <DashboardHeader />
                        <Container className="db-bids-wrapper loa-bids">
                            <MyBidsPanel
                                storeTheme={'Lotsofauctions'}
                                gridView={true}
                                isGFDashMenuList={true}
                            />
                        </Container>
                    </div>
                ) : (
                    <>
                        <DashboardHeader />
                        <Container className="db-bids-wrapper mt-4 loa-bids">
                            <h2 className="mp-head">MY BIDS</h2>
                            <MyBidsPanel storeTheme={'Lotsofauctions'} gridView={true} />
                        </Container>
                    </>
                )}
            </Layout>
        </>
    )
}

export default Dashboard
